import { useEffect } from "react";
import { useLocation } from "wouter";
import { serviceData } from "@/pages/services/serviceData";
import { faqItems } from "@/lib/faq";
import { schwaebischHallFaqs } from "@/pages/garagentore-schwaebisch-hall";
import { pfedelbachFaqs } from "@/pages/garagentore-pfedelbach";
import { heilbronnFaqs } from "@/pages/garagentore-heilbronn";
import { neuensteinFaqs } from "@/pages/garagentore-neuenstein";
import { kuenzelsauFaqs } from "@/pages/garagentore-kuenzelsau";
import { bretzfeldFaqs } from "@/pages/garagentore-bretzfeld";
import { neuenstadtAmKocherFaqs } from "@/pages/garagentore-neuenstadt-am-kocher";
import { kupferzellFaqs } from "@/pages/garagentore-kupferzell";

const siteUrl = "https://tts-britz.de";
const siteName = "Tür- und Torservice Britz";
const defaultDescription =
  "Tür- und Torservice Britz aus Öhringen: Meisterbetrieb für Garagentore, Industrietore, Brandschutztüren, UVV-Prüfungen, Einbruchschutz und Metallbauarbeiten.";
const mainNavigation = [
  { name: "Leistungen", url: `${siteUrl}/leistungen` },
  { name: "Garagentore", url: `${siteUrl}/garagentore` },
  { name: "Industrietore", url: `${siteUrl}/industrietore` },
  { name: "Brandschutztüren und Tore", url: `${siteUrl}/brandschutztueren-tore` },
  { name: "UVV-Prüfungen", url: `${siteUrl}/uvv-pruefung` },
  { name: "Metallbauarbeiten", url: `${siteUrl}/metallbauarbeiten` },
  { name: "Einbruchschutz", url: `${siteUrl}/einbruchschutz` },
  { name: "Verladebrücken", url: `${siteUrl}/verladebruecken` },
  { name: "Über uns", url: `${siteUrl}/ueber-uns` },
  { name: "Zertifikate", url: `${siteUrl}/zertifikate` },
  { name: "Kontakt", url: `${siteUrl}/kontakt` },
];

const staticPages: Record<string, { title: string; description: string }> = {
  "/": {
    title: "Tür- und Torservice Britz | Öhringen",
    description: defaultDescription,
  },
  "/ueber-uns": {
    title: "Über uns | Tür- und Torservice Britz aus Öhringen",
    description:
      "Tür- und Torservice Britz aus Öhringen-Eckartsweiler: regionaler Meisterbetrieb für Türen, Tore, Metallbau und Sicherheit in Hohenlohe.",
  },
  "/kontakt": {
    title: "Kontakt | Tür- und Torservice Britz in Öhringen",
    description:
      "Kontakt zu Tür- und Torservice Britz in Öhringen-Eckartsweiler: Anfrage zu Türen, Toren, UVV-Prüfungen, Metallbau und Sicherheit stellen.",
  },
  "/garagentore/schwaebisch-hall": {
    title: "Garagentore Schwäbisch Hall | Montage & Service | TTS Britz",
    description: "Garagentore in Schwäbisch Hall vom Meisterbetrieb TTS Britz: persönliche Beratung, Montage, Torantriebe, Wartung und Service. Jetzt anfragen.",
  },
  "/garagentore/pfedelbach": {
    title: "Garagentore Pfedelbach | Montage & Service | TTS Britz",
    description: "Garagentore in Pfedelbach vom Meisterbetrieb aus Öhringen: Beratung, Montage, Torantriebe, Modernisierung, Reparatur und Service.",
  },
  "/garagentore/heilbronn": {
    title: "Garagentore Heilbronn | Montage & Service | TTS Britz",
    description: "Garagentore in Heilbronn vom Meisterbetrieb TTS Britz: Beratung, Montage, Torantriebe, Modernisierung, Wartung und Reparatur.",
  },
  "/garagentore/neuenstein": {
    title: "Garagentore Neuenstein | Montage & Service | TTS Britz",
    description: "Garagentore in Neuenstein vom Meisterbetrieb aus Öhringen: Beratung, Montage, Torantriebe, Modernisierung, Reparatur und Service.",
  },
  "/garagentore/kuenzelsau": {
    title: "Garagentore Künzelsau | Montage & Service | TTS Britz",
    description: "Garagentore in Künzelsau vom Meisterbetrieb aus Öhringen: Beratung, Montage, Torantriebe, Modernisierung, Reparatur und Service.",
  },
  "/garagentore/bretzfeld": {
    title: "Garagentore Bretzfeld | Montage & Service | TTS Britz",
    description: "Garagentore in Bretzfeld vom Meisterbetrieb aus Öhringen: Beratung, Montage, Torantriebe, Modernisierung, Reparatur und Service.",
  },
  "/garagentore/neuenstadt-am-kocher": {
    title: "Garagentore Neuenstadt am Kocher | TTS Britz",
    description: "Garagentore in Neuenstadt am Kocher: Beratung, Montage, Sektionaltore, Antriebe, Modernisierung, Reparatur und Service durch TTS Britz.",
  },
  "/garagentore/kupferzell": {
    title: "Garagentore Kupferzell | Montage & Service | TTS Britz",
    description: "Garagentore in Kupferzell: Beratung, Montage, Sektionaltore, Antriebe, Modernisierung, Reparatur und Service durch TTS Britz aus Öhringen.",
  },
  "/leistungen": {
    title: "Leistungen | Tür- und Torservice Britz in Öhringen",
    description:
      "Unsere Leistungen: Garagentore, Industrietore, Brandschutztüren, UVV-Prüfungen, Metallbauarbeiten, Einbruchschutz und Verladebrücken in der Region Hohenlohe.",
  },
  "/zertifikate": {
    title: "Zertifikate & Nachweise | Tür- und Torservice Britz",
    description:
      "Zertifikate, Meisterbriefe und Nachweise von Tür- und Torservice Britz: Qualifikationen, ISO 9001:2015 und fachliche Nachweise.",
  },
  "/impressum": {
    title: "Impressum | Tür- und Torservice Britz",
    description: "Impressum und Anbieterkennzeichnung von Tür- und Torservice Britz aus Öhringen-Eckartsweiler.",
  },
  "/datenschutz": {
    title: "Datenschutz | Tür- und Torservice Britz",
    description: "Datenschutzerklärung von Tür- und Torservice Britz.",
  },
};

const servicePages: Record<string, { title: string; description: string }> = {
  "/garagentore": {
    title: "Garagentore in Öhringen | Reparatur, Wartung & Service",
    description:
      "Tür- und Torservice Britz ist Ihr Ansprechpartner für Garagentore in Öhringen und Umgebung: Reparatur, Wartung, Service und Lösungen rund ums Tor.",
  },
  "/industrietore": {
    title: "Industrietore in Öhringen | Wartung, Reparatur & Prüfung",
    description:
      "Service für Industrietore in Öhringen, Hohenlohe und Umgebung: Wartung, Reparatur, Instandsetzung und Prüfung durch den Meisterbetrieb Britz.",
  },
  "/brandschutztueren-tore": {
    title: "Brandschutztüren & Brandschutztore in Öhringen",
    description:
      "Montage, Wartung und Instandsetzung von Brandschutztüren und Brandschutztoren in Öhringen und Umgebung durch Tür- und Torservice Britz.",
  },
  "/uvv-pruefung": {
    title: "UVV-Prüfungen für Tore & Türen in Öhringen",
    description:
      "Tür- und Torservice Britz führt UVV-Prüfungen an Türen, Toren und Toranlagen in Öhringen, Hohenlohe und Umgebung fachgerecht durch.",
  },
  "/metallbauarbeiten": {
    title: "Metallbauarbeiten in Öhringen | Tür- und Torservice Britz",
    description:
      "Metallbauarbeiten vom Meisterbetrieb in Öhringen: Tür- und Torservice Britz unterstützt Privatkunden, Gewerbe, Industrie und Hausverwaltungen.",
  },
  "/einbruchschutz": {
    title: "Einbruchschutz in Öhringen | Türen, Tore & Fenstersicherung",
    description:
      "Einbruchschutz für Türen, Tore und Fenster in Öhringen und Umgebung: Beratung, Montage und Sicherheitslösungen vom Meisterbetrieb Britz.",
  },
  "/verladebruecken": {
    title: "Verladebrücken in Öhringen | Wartung, Service & Montage",
    description:
      "Tür- und Torservice Britz unterstützt bei Verladebrücken in Öhringen und Umgebung: Montage, Wartung, Prüfung und Instandsetzung für Gewerbe und Industrie.",
  },
};

const fallbackServiceTitleSuffix = "Öhringen | Tür- und Torservice Britz";

const normalizePath = (path: string) => {
  const cleanPath = path.split("?")[0].split("#")[0];
  if (cleanPath === "/index.html") return "/";
  return cleanPath === "" ? "/" : cleanPath;
};

const pathsWithFaq = new Set(["/", "/ueber-uns", "/kontakt"]);

const trimDescription = (text: string) => {
  const cleaned = text.replace(/\s+/g, " ").trim();
  if (cleaned.length <= 158) return cleaned;
  return `${cleaned.slice(0, 155).trim()}...`;
};

const setMetaTag = (selector: string, attr: "content" | "href", value: string, create: () => HTMLMetaElement | HTMLLinkElement) => {
  let element = document.head.querySelector<HTMLMetaElement | HTMLLinkElement>(selector);

  if (!element) {
    element = create();
    document.head.appendChild(element);
  }

  element.setAttribute(attr, value);
};

const upsertJsonLd = (id: string, data: Record<string, unknown>) => {
  let script = document.getElementById(id) as HTMLScriptElement | null;

  if (!script) {
    script = document.createElement("script");
    script.id = id;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }

  script.textContent = JSON.stringify(data);
};

const removeJsonLd = (id: string) => {
  document.getElementById(id)?.remove();
};

export default function SEO() {
  const [location] = useLocation();

  useEffect(() => {
    const path = normalizePath(location);
    const service = serviceData.find((item) => item.route === path);
    const page = service
      ? servicePages[path] ?? {
          title: `${service.title} ${fallbackServiceTitleSuffix}`,
          description: trimDescription(service.subtitle || service.description[0] || defaultDescription),
        }
      : staticPages[path] ?? {
          title: `${siteName} | Türen, Tore & Metallbau in Öhringen`,
          description: defaultDescription,
        };

    const canonicalUrl = `${siteUrl}${path === "/" ? "/" : path}`;
    const imageUrl = `${siteUrl}/opengraph.jpg`;

    document.title = page.title;

    setMetaTag('meta[name="robots"]', "content", "index,follow", () => {
      const meta = document.createElement("meta");
      meta.name = "robots";
      return meta;
    });

    setMetaTag('meta[name="description"]', "content", page.description, () => {
      const meta = document.createElement("meta");
      meta.name = "description";
      return meta;
    });

    setMetaTag('link[rel="canonical"]', "href", canonicalUrl, () => {
      const link = document.createElement("link");
      link.rel = "canonical";
      return link;
    });

    [
      ["og:locale", "de_DE"],
      ["og:type", service ? "article" : "website"],
      ["og:site_name", siteName],
      ["og:title", page.title],
      ["og:description", page.description],
      ["og:url", canonicalUrl],
      ["og:image", imageUrl],
      ["twitter:card", "summary_large_image"],
      ["twitter:title", page.title],
      ["twitter:description", page.description],
      ["twitter:image", imageUrl],
    ].forEach(([property, content]) => {
      const selector = property.startsWith("twitter:")
        ? `meta[name="${property}"]`
        : `meta[property="${property}"]`;

      setMetaTag(selector, "content", content, () => {
        const meta = document.createElement("meta");
        if (property.startsWith("twitter:")) {
          meta.name = property;
        } else {
          meta.setAttribute("property", property);
        }
        return meta;
      });
    });

    upsertJsonLd("local-business-schema", {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${siteUrl}/#unternehmen`,
      name: siteName,
      url: siteUrl,
      image: imageUrl,
      logo: `${siteUrl}/favicon.png`,
      telephone: "+49794133514",
      email: "info@tts-britz.de",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Eichklingenweg 7",
        postalCode: "74613",
        addressLocality: "Öhringen-Eckartsweiler",
        addressCountry: "DE",
      },
      areaServed: ["Öhringen", "Hohenlohe", "Neuenstein", "Bretzfeld", "Pfedelbach", "Waldenburg"],
      priceRange: "$$",
      makesOffer: serviceData.map((item) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: item.title,
          url: `${siteUrl}${item.route}`,
          description: trimDescription(item.subtitle || item.description[0]),
        },
      })),
    });

    upsertJsonLd("website-schema", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      name: siteName,
      alternateName: "TTS Britz",
      url: `${siteUrl}/`,
      inLanguage: "de-DE",
      publisher: {
        "@id": `${siteUrl}/#unternehmen`,
      },
    });

    upsertJsonLd("site-navigation-schema", {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "@id": `${siteUrl}/#seitenstruktur`,
      name: "Wichtige Seiten von Tür- und Torservice Britz",
      itemListElement: mainNavigation.map((item, index) => ({
        "@type": "SiteNavigationElement",
        position: index + 1,
        name: item.name,
        url: item.url,
      })),
    });

    const breadcrumbItems = [
      {
        "@type": "ListItem",
        position: 1,
        name: "Startseite",
        item: `${siteUrl}/`,
      },
    ];

    if (path === "/garagentore/kupferzell") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Kupferzell", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Kupferzell", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Kupferzell"],
      });
    } else if (path === "/garagentore/neuenstadt-am-kocher") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Neuenstadt am Kocher", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Neuenstadt am Kocher", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Neuenstadt am Kocher"],
      });
    } else if (path === "/garagentore/bretzfeld") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Bretzfeld", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Bretzfeld", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Bretzfeld"],
      });
    } else if (path === "/garagentore/kuenzelsau") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Künzelsau", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Künzelsau", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Künzelsau"],
      });
    } else if (path === "/garagentore/neuenstein") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Neuenstein", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Neuenstein", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Neuenstein"],
      });
    } else if (path === "/garagentore/heilbronn") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Heilbronn", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Heilbronn", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` }, areaServed: ["Heilbronn"],
      });
    } else if (path === "/garagentore/pfedelbach") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Pfedelbach", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Pfedelbach", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` },
        areaServed: ["Pfedelbach", "Harsberg", "Heuberg", "Buchhorn", "Gleichen", "Oberohrn", "Untersteinbach", "Windischenbach"],
      });
    } else if (path === "/garagentore/schwaebisch-hall") {
      breadcrumbItems.push(
        { "@type": "ListItem", position: 2, name: "Garagentore", item: `${siteUrl}/garagentore` },
        { "@type": "ListItem", position: 3, name: "Garagentore Schwäbisch Hall", item: canonicalUrl },
      );
      upsertJsonLd("service-schema", {
        "@context": "https://schema.org", "@type": "Service", "@id": `${canonicalUrl}#service`,
        name: "Garagentore in Schwäbisch Hall", description: page.description, serviceType: "Garagentore",
        url: canonicalUrl, provider: { "@id": `${siteUrl}/#unternehmen` },
        areaServed: ["Schwäbisch Hall", "Michelfeld", "Rosengarten", "Mainhardt", "Untermünkheim"],
      });
    } else if (service) {
      breadcrumbItems.push(
        {
          "@type": "ListItem",
          position: 2,
          name: "Leistungen",
          item: `${siteUrl}/leistungen`,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: service.title,
          item: canonicalUrl,
        },
      );

      upsertJsonLd("service-schema", {
        "@context": "https://schema.org",
        "@type": "Service",
        "@id": `${canonicalUrl}#service`,
        name: service.title,
        description: page.description,
        serviceType: service.title,
        url: canonicalUrl,
        provider: {
          "@id": `${siteUrl}/#unternehmen`,
        },
        areaServed: ["Öhringen", "Hohenlohe", "Neuenstein", "Bretzfeld", "Pfedelbach", "Waldenburg"],
      });
    } else if (path !== "/") {
      breadcrumbItems.push({
        "@type": "ListItem",
        position: 2,
        name: page.title.split("|")[0].trim(),
        item: canonicalUrl,
      });

      removeJsonLd("service-schema");
    } else {
      removeJsonLd("service-schema");
    }

    upsertJsonLd("breadcrumb-schema", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbItems,
    });

    if (pathsWithFaq.has(path)) {
      upsertJsonLd("faq-schema", {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      });
    } else if (path === "/garagentore/schwaebisch-hall") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: schwaebischHallFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/pfedelbach") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: pfedelbachFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/heilbronn") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: heilbronnFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/neuenstein") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: neuensteinFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/kuenzelsau") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: kuenzelsauFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/bretzfeld") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: bretzfeldFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/neuenstadt-am-kocher") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: neuenstadtAmKocherFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else if (path === "/garagentore/kupferzell") {
      upsertJsonLd("faq-schema", { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: kupferzellFaqs.map(([question, answer]) => ({ "@type": "Question", name: question, acceptedAnswer: { "@type": "Answer", text: answer } })) });
    } else {
      removeJsonLd("faq-schema");
    }
  }, [location]);

  return null;
}
